import { useState, useEffect } from 'react';
import { Alert, Box, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, MenuItem, Select, Stack, Tooltip } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { SimpleTreeView } from '@mui/x-tree-view';
import { ClearIcon } from '@mui/x-date-pickers';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { Icon as Iconify } from '@iconify/react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import CloseIcon from '@mui/icons-material/Close';
import { useSchemeStore } from '../schemeStore';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import schemedefinationService from '../../../services/schemedefination.service';

export default function SchemeArea() {

    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;

    const {
        schemeDetails,
        schemeId,
        formData,
        updateScheme,
        tabValue,
        prevTabValue,
        setAreaData,
        addScheme
    } = useSchemeStore();

    const [loading, setLoading] = useState(false);
    const { handleSubmit, setValue, register, control, formState: { errors } } = useForm();
    const { enqueueSnackbar } = useSnackbar();
    const [showErrorMessages, setShowErrorMessages] = useState(false); // NOSONAR
    const { id } = useParams();
    const navigate = useNavigate();


    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);


    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }
    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }


    const idKey = location.pathname.includes('schemedefination/newscheme') ? schemeId : id;

    function updatePayload(payload) {
        return {
            SchemeJSON: payload.SchemeJSON.map(scheme => {
                const {
                    FromDate,
                    ToDate,
                    LiftingUOM,
                    SchemeData,
                    Item,
                    Slabs,
                    Target,
                    Point,
                    Retailer,
                    Distributor,
                    Area,
                    ContributionItem,
                    MailCirculation,
                    SchemeDocument
                } = scheme;

                let Filterss = [
                    Item.length > 0 ? Item[0] : undefined,
                    Retailer.length > 0 ? Retailer[0] : undefined,
                    Distributor.length > 0 ? Distributor[0] : undefined, // Check if Distributor array has elements
                    Area, // Check if Area array has elements
                ];

                Filterss = Filterss.filter(filter => filter != null && (!Array.isArray(filter) || filter.length > 0));

                return {
                    FromDate,
                    ToDate,
                    LiftingUOM,
                    Scheme: {
                        Id: idKey,
                        ...SchemeData,
                        Point,
                        Filters: Filterss,
                        Slabs,
                        ContributionItem,
                        Target,
                        MailCirculation,
                        SchemeDocument,
                    },

                };
            })
        };
    }



    function generateDetailsArray(selectedItems, selectedItems2, fullFetchedNodes) {
        const details = {};
        const conditionalStatements = [];

        selectedItems.forEach((item) => {
            const node = fullFetchedNodes.find(nodee => nodee.AreaId === item);
            if (node) {
                const key = `IN:${node.ColumnName}`;
                if (!details[key]) {
                    details[key] = [];
                    conditionalStatements.push(`IN:${node.ColumnName}`);
                }
                details[key].push(item);
            }
        });

        selectedItems2.forEach((item) => {
            const node = fullFetchedNodes.find(nodee => nodee.AreaId === item);
            if (node) {
                const key = `NotIN:${node.ColumnName}`;
                if (!details[key]) {
                    details[key] = [];
                    conditionalStatements.push(`NotIN:${node.ColumnName}`);
                }
                details[key].push(item);
            }
        });

        // If no conditions, return an empty array
        if (conditionalStatements.length === 0) {
            return [];
        }

        const formattedDetails = {};
        let index = 1;

        Object.keys(details).forEach((key) => {
            const [condition, columnName] = key.split(':');
            formattedDetails[`${index}!${columnName}`] = details[key];
            conditionalStatements[conditionalStatements.indexOf(key)] = `${index}!${condition}:${columnName}`;
            // eslint-disable-next-line no-plusplus
            index++;
        });

        const conditionalStatement = `( ${conditionalStatements.join(' AND ')} )`;

        return [
            {
                ...formattedDetails,
                ConditionalStatement: conditionalStatement
            }
        ]
    }

    /* Get All Descendents Code start */

    function findAreaByIdentifier(area, areaId) {

        if (!area) {
            return null;
        }


        if (area?.AreaId === areaId || area?.AreaParentId === areaId) {
            return area;
        }

        if (Array.isArray(area.Areas) && area.Areas.length > 0) {
            const foundArea = area.Areas.map(childArea => findAreaByIdentifier(childArea, areaId))
                .find(result => result !== null);
            return foundArea || null;
        }

        return null;
    }

    function getAllAreaIdentifiers(area) {
        let ids = [];

        // If there are child areas, traverse them recursively
        if (area.Areas && area.Areas.length > 0) {
            area.Areas.forEach(childArea => {
                ids = ids.concat(getAllAreaIdentifiers(childArea));
            });
        }

        // Add the current area's ID after all children
        if (area.AreaId) {
            ids.push(area.AreaId);
        }

        return ids;
    }

    function getDescendantIdentifiers(areaData, targetAreaId) {
        // Find the area by ID
        const targetArea = findAreaByIdentifier(areaData, targetAreaId);

        // If area is found, get all descendant IDs
        if (targetArea) {
            return getAllAreaIdentifiers(targetArea).filter(identifier => identifier !== targetAreaId); // Exclude the target area's ID
        }

        return []; // Return an empty array if no area found with the given ID
    }

    /* Get All Descendents Code end */

    const filterChildren = (fullTreeData, arr) => {
        // Create a new array to hold the filtered IDs
        const filteredArr = [...arr];

        arr.forEach((idd) => {
            // Get all descendant identifiers for the current idd
            const allChilds = getDescendantIdentifiers(fullTreeData, idd);

            // Remove all descendants from the filteredArr
            allChilds.forEach((childId) => {
                const index = filteredArr.indexOf(childId);
                if (index !== -1) {
                    filteredArr.splice(index, 1); // Remove the child ID from the array
                }
            });
        });

        return filteredArr; // Return the filtered array
    }




    const onSubmit = () => {

        setLoading(true);

        try {
            setLoading(true);

            const filtered1 = filterChildren(treeData, selectedItems);
            const filtered2 = filterChildren(treeData, selectedItems2);
            const generatedDetails = generateDetailsArray(filtered1, filtered2, fullFetchedNodes);
         

            let area;
            if (generatedDetails.length > 0) {
                area = {
                    FilterType: "Area",
                    Details: generatedDetails
                };
            } else {
                area = []; // explicitly pass empty array
            }
           


            const payload = schemeDetails;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;

            if (selectedItems.length === 0 && selectedItems2.length === 0) {
                setLoading(false);
                return;
            }
            payload.Area = area;


            const payloadd = {
                "SchemeJSON": [
                    payload
                ]
            }

            const finalPayload = updatePayload(payloadd);

            const formDataa = new FormData();

            formDataa.append('files', null);

            formDataa.append('schemeJSON', JSON.stringify(finalPayload));


                setLoading(true);
                schemedefinationService.then(schemeDefinationInstance => {
                    schemeDefinationInstance.UpdateScheme(formData)
                        .then(response => {
                            if (response.status === 200) {
                                setLoading(false);
                                displayAlert('success', response.data.Message, true);
                                setTimeout(() => {
                                    hideAlert();
                                    navigate('/scheme/scheme-definition');
                                }, 2000);
                            } else {
                                setLoading(false);
                                displayAlert('success', response.data.Message, true);
                                setTimeout(() => {
                                    hideAlert();
                                }, 2000);
                            }
                        })
                        .catch(er => {
                             //  console.log("Error Updating Scheme: ", er);
                            setLoading(false);
                        });
                });
            setLoading(false);

        } catch (error) {
            console.error('Error occured: ', error);
            enqueueSnackbar('Error updating scheme', { variant: 'error' });
            setLoading(false);
        }


    }


    /* TREEVIEW BELOW RESTRICTED AREA DO NOT ENTER WITHOUT PERMISSION */

    const [defaultType, setDefaultType] = useState(String(schemeDetails?.Area[0]?.Details[0]?.ConditionalStatement).includes('NotIN') ? 'NotIN' : 'IN');


    function extractIDs(details) {
         //  console.log("details: ", details);
        const { ConditionalStatement, ...areaDetails } = details[0];

        const inIdsSet = new Set();
        const notInIdsSet = new Set();

        // Regex to extract conditions from the statement
        const inPattern = /(\d+)!IN:([A-Za-z-]+)/g;  // NOSONAR
        const notInPattern = /(\d+)!NotIN:([A-Za-z-]+)/g;  // NOSONAR

        // Extract "IN" conditions
        let match = inPattern.exec(ConditionalStatement);
        while (match !== null) {
            const key = `${match[1]}!${match[2]}`;
            if (areaDetails[key]) {
                areaDetails[key].forEach(idd => inIdsSet.add(idd));
            }
            match = inPattern.exec(ConditionalStatement);
        }

        // Extract "NotIN" conditions
        let matchNotIn = notInPattern.exec(ConditionalStatement);
        while (matchNotIn !== null) {
            const key = `${matchNotIn[1]}!${matchNotIn[2]}`;
            if (areaDetails[key]) {
                areaDetails[key].forEach(idd => notInIdsSet.add(idd));
            }
            matchNotIn = notInPattern.exec(ConditionalStatement);
        }

        // Convert the sets back to arrays
        const inIds = Array.from(inIdsSet);
        const notInIds = Array.from(notInIdsSet);

        return { inIds, notInIds };
    }


    useEffect(() => {
        try {
            const fetchIds = [];

            const extractedIds = extractIDs(schemeDetails?.Area[0]?.Details);
            const { inIds } = extractedIds;
            const { notInIds } = extractedIds;

            setSelectedItems(prevSelectedItems => [...prevSelectedItems, ...inIds]);
            setSelectedItems2(prevSelectedItems2 => [...prevSelectedItems2, ...notInIds]);

            schemeDetails?.Area[0]?.Details.forEach(item => {
                Object.values(item).forEach(value => {
                    if (Array.isArray(value)) {
                        value.forEach(areaId => fetchIds.push(areaId));
                    }
                });
            });


                setLoading(true);
                schemedefinationService.then(schemeDefinationInstance => {
                    schemeDefinationInstance.GetSchemeAreaDetails(fetchIds.join(','))
                        .then(response => {
                            if (response.status === 200) {
                                const newNodes = response.data.map((item) => ({
                                    AreaId: item.value,
                                    AreaName: item.text,
                                    ColumnName: item.ColumnName,
                                    IsChield: item.IsChild,
                                }));


                                setFullFetchedNodes(prevNodes => [...prevNodes, ...newNodes]);

                            } else {
                                 //  console.log("Error getting area details", response);
                            }
                        })
                        .catch(er => {
                             //  console.log("Error getting area details: ", er);
                        });
                });
            
            setLoading(false);
        } catch (error) {
            console.error("Error fetching areas: ", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails]);



    const [fetchId, setFetchId] = useState(null);
    const [treeData, setTreeData] = useState(null);
    const [lastSelectedItem, setLastSelectedItem] = useState(null); // For IN
    const [lastSelectedItem2, setLastSelectedItem2] = useState(null); // For NotIN
    const [fetchedNodes, setFetchedNodes] = useState([]);
    const [fullFetchedNodes, setFullFetchedNodes] = useState([{
        "ColumnName": "AreaLevelMaster-COUNTRY",
        "AreaId": "000000000000001",
        "AreaName": "INDIA",
        "IsChield": true
    }]);
    const [expandedItems, setExpandedItems] = useState([]);

    useEffect(() => {
         //  console.log("treedata: ", treeData);
    }, [treeData]);


    useEffect(() => {
        const initializeTree = async () => {
            const fetchData = async (idd) => {
                try {
                    const schemeDefinationInstance = await schemedefinationService;
                    const response = await schemeDefinationInstance.GetArea(idd);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching tree data:', error);
                    return null;
                }
            };

            const initialData = await fetchData(fetchId);
            if (initialData) {
                setTreeData(initialData);
                setFetchedNodes([initialData.AreaParentId]); // Mark the root node as fetched
                initialData?.Areas?.forEach((item) => setFullFetchedNodes(prevFullNodes => [...prevFullNodes, item]))
            }
        };

        if (fetchId != null) {
            initializeTree();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchId]);

    const clearSelection = (fieldName) => {
        setLastSelectedItem(null);
        setLastSelectedItem2(null); // Reset both last selected items
        setValue(fieldName, null);
    };

    const fetchAndSetChildNodes = async (itemId) => {
        if (fetchedNodes.includes(itemId)) {
            return; // If node already fetched, return early
        }

        const currentItem = findAreaById(treeData, itemId);
        if (!currentItem || !currentItem.IsChield) {
            return; // If current item does not have children, return early
        }

        try {

            const schemeDefinationInstance = await schemedefinationService;
            const res = await schemeDefinationInstance.GetArea(itemId);
            const childData = res.data;


            if (childData) {
                const updatedTreeData = {
                    ...treeData,
                    Areas: updateAreasWithChildren(treeData.Areas, itemId, childData.Areas)
                };
                setTreeData(updatedTreeData);
                setFetchedNodes([...fetchedNodes, itemId]);
                childData?.Areas?.forEach((item) => setFullFetchedNodes(prevFullNodes => [...prevFullNodes, item]))

            }
        } catch (error) {
            console.error('Error fetching and updating child nodes:', error);
        }
    };

    const findAreaById = (dataa, idd) => {
        if (!dataa || !dataa.Areas) return null;
        // eslint-disable-next-line no-restricted-syntax
        for (const area of dataa.Areas) {
            if (area.AreaId === idd) return area;
            const found = findAreaById(area, idd);
            if (found) return found;
        }
        return null;
    };

    const updateAreasWithChildren = (areas, parentId, children) => areas.map(area =>
        area.AreaId === parentId
            ? { ...area, childrenFetched: true, Areas: children || [] }
            : { ...area, Areas: updateAreasWithChildren(area.Areas || [], parentId, children) }
    );

    const handleExpandedItemsChange = async (event, itemIds) => {
        event.stopPropagation();
        event.preventDefault();
        setLoading(true);
        await fetchAndSetChildNodes(itemIds[0]);
        setLoading(false);
        setExpandedItems(itemIds);
    };


    const handleItemSelectionToggle = async (event, itemId, isSelected, fieldName) => {

        event.stopPropagation();
        event.preventDefault();
        if (isSelected) {
            const itemLabel = event.target.innerText;
            const treeItem = { AreaId: itemId, Area: itemLabel };

            if (defaultType === 'IN') {
                setLastSelectedItem(treeItem);
            } else {
                setLastSelectedItem2(treeItem);
            }


            // Check if child nodes need to be fetched
            const isChildAlreadyFetched = treeData?.Areas?.find(area => area.AreaId === itemId && area.childrenFetched);
            if (!isChildAlreadyFetched) {
                setLoading(true);
                await fetchAndSetChildNodes(itemId);
                setLoading(false);

            }
        }

    };



    let uniqueIdCounter = 0;
    const generateUniqueId = () => {
        const uniqueId = uniqueIdCounter;
        uniqueIdCounter += 1;
        return uniqueId;
    };

    const renderTreeItems = (areas, parentExpanded = false) => areas.map((area) =>
    (
        <TreeItem
            key={area.AreaId}
            itemId={area.AreaId}
            label={area.AreaName}
            expanded={parentExpanded && area.expanded}
            onNodeToggle={() => handleNodeToggle(area.AreaId)}
            nodeId={area.AreaId.toString()} // Assigning nodeId for correct arrow rendering
            sx={{
                '& .MuiTreeItem-label': {
                    fontSize: '13px', // Custom font size
                },
            }}
        >
            {area.Areas && renderTreeItems(area.Areas, parentExpanded && area.expanded)}
            {
                area?.IsChield && (<TreeItem itemId={generateUniqueId()} sx={{ display: 'none' }}> </TreeItem>)
            }


        </TreeItem>
    ));

    const handleNodeToggle = (itemId) => {
        setTreeData(prevTreeData => {
            const updatedAreas = updateExpandedState(prevTreeData.Areas, itemId);
            return { ...prevTreeData, Areas: updatedAreas };
        });
    };

    const updateExpandedState = (areas, itemId) => areas.map(area =>
        area.AreaId === itemId
            ? { ...area, expanded: !area.expanded }
            : { ...area, Areas: updateExpandedState(area.Areas || [], itemId) }
    );


    const [selectedItems, setSelectedItems] = useState([]); // used for In
    const [selectedItems2, setSelectedItems2] = useState([]); // used for NotIn

    const handleSelectedItemsChange = (event, ids) => {
        const selectedIds = [...ids].reverse();
        setSelectedItems(selectedIds);
    };

    const handleSelectedItemsChange2 = (event, ids) => {
        const selectedIds = [...ids].reverse();
        setSelectedItems2(selectedIds);
    };



    useEffect(() => {
        if (prevTabValue.name === 'Area') {

            formDataSave();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);


    const formDataSave = async () => {
         //  console.log("saveData called");

        try {

            const filtered1 = filterChildren(treeData, selectedItems);
            const filtered2 = filterChildren(treeData, selectedItems2);
            const generatedDetails = generateDetailsArray(filtered1, filtered2, fullFetchedNodes);


            let area;
            if (generatedDetails.length > 0) {
                area = {
                    FilterType: "Area",
                    Details: generatedDetails
                };
            } else {
                area = []; // explicitly pass empty array
            }



            setAreaData(area);
            

           

        } catch (err) {
               console.log("Err: ", err);
        }
    }

    async function saveData() {
         //  console.log("saveData called");

        try {

            const filtered1 = filterChildren(treeData, selectedItems);
            const filtered2 = filterChildren(treeData, selectedItems2);
            const generatedDetails = generateDetailsArray(filtered1, filtered2, fullFetchedNodes);

            let area;
            if (generatedDetails.length > 0) {
                area = {
                    FilterType: "Area",
                    Details: generatedDetails
                };
            } else {
                area = []; // explicitly pass empty array
            }

             //  console.log("area Payload: ", area);
         

            if (selectedItems.length === 0 && selectedItems2.length === 0) {
                try {
                    if (isCopyScheme) {
                        const result = await addScheme(); // NOSONAR
                    } else {

                        const result = await updateScheme(); // NOSONAR
                    } 
                } catch (err) {
                    // handle error
                }
                return;
            }


          
            setAreaData(area);
            try {
                if (isCopyScheme) {
                    const result = await addScheme(); // NOSONAR
                } else {

                    const result = await updateScheme(); // NOSONAR
                }
            } catch (err) {
                // handle error
            }
     

        } catch (err) {
             //  console.log("Err: ", err);
        }
    }



    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', flexGrow: 1, height: '100%' }}>
                <Box
                    rowGap={2}
                    columnGap={2}
                    display="flex"
                    gap={2}
                    sx={{ mt: 2, flexGrow: 1 }}

                >

                    <FormControl style={{ width: '150px' }} size='small'>
                        <style>
                            {`.css-1d1wxla-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {color: #424242 !important;}`}
                        </style>
                        <InputLabel style={{ fontSize: '14px' }} size="small">Type</InputLabel>
                        <Select
                            size="small"
                            label='Type'
                            defaultValue={defaultType}
                            {...register('filterType', { required: 'Type is required' })}
                            onChange={(e) => {
                                setDefaultType(e.target.value);
                            }}
                            style={{ fontSize: '13px' }}
                        >
                            <MenuItem style={{ fontSize: '13px' }} value='IN'>IN</MenuItem>
                            <MenuItem style={{ fontSize: '13px' }} value='NotIN'>Not IN</MenuItem>
                        </Select>
                        {errors.filterType && <FormHelperText error style={{ color: 'red', fontSize: '10px' }}>{errors.filterType.message}</FormHelperText>}
                    </FormControl>


                    <FormControl variant="outlined" size="small" sx={{ width: '350px' }}>

                        <Controller
                            name='Area'
                            doit={fetchId === null ? setFetchId('000000000000001') : () => { }}  // NOSONAR
                            // defaultValue={(pageType === 'edit') ? { AreaId: field.DefaultValues[0]?.AreaId, Area: field.DefaultValues[0]?.AreaName } : null}
                            control={control}
                            render={({ field: controllerField }) => (  // NOSONAR 
                                <FormControl fullWidth variant="outlined" size="small" >
                                    <style>
                                        {
                                            ` .css-gescg-MuiTreeItem-content .MuiTreeItem-label {
                                                                    font-size: 13px;
                                                                } `
                                        }
                                    </style>
                                    <InputLabel
                                        size='small'
                                        sx={{
                                            '&.Mui-focused': {
                                                color: '#424242',
                                            },
                                        }}
                                        style={{ fontSize: '14px' }}
                                    >
                                        Area
                                    </InputLabel>
                                    <Select
                                        value={defaultType === 'IN' ?
                                            selectedItems.map(item => {
                                                const node = fullFetchedNodes.find(nodee => nodee.AreaId === item);
                                                return node ? node.AreaName : '';
                                            }) :
                                            selectedItems2.map(item => {
                                                const node = fullFetchedNodes.find(nodee => nodee.AreaId === item);
                                                return node ? node.AreaName : '';
                                            })
                                        }
                                        label="Area"
                                        size="small"
                                        style={{ fontSize: '13px' }}
                                        defaultValue={defaultType}
                                        multiple
                                        onChange={(e) => {
                                            if (defaultType === 'IN') {  // NOSONAR
                                                controllerField.onChange(e.target.value);
                                            } else {
                                                controllerField.onChange(e.target.value);
                                            }
                                        }}

                                        renderValue={(selected) => {
                                            const displayValue = defaultType === 'IN' ?
                                                filterChildren(treeData, selectedItems).map(item => {
                                                    const node = fullFetchedNodes.find(nodee => nodee.AreaId === item);
                                                    return node ? `${node.AreaName}, ` : '';
                                                }).join('').slice(0, -2) :
                                                filterChildren(treeData, selectedItems2).map(item => {
                                                    const node = fullFetchedNodes.find(nodee => nodee.AreaId === item);
                                                    return node ? `${node.AreaName}, ` : '';
                                                }).join('').slice(0, -2);

                                            const displayValueShortened = displayValue.length > 30 ? `${displayValue.slice(0, 30)}...` : displayValue;

                                            return (
                                                <Tooltip title={displayValue}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        maxWidth: '100%',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        {displayValueShortened}
                                                    </Box>
                                                </Tooltip>
                                            );
                                        }}
                                        sx={{
                                            width: '100%', // Set a fixed width
                                            '& .MuiSelect-root': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }
                                        }}
                                        endAdornment={
                                            (defaultType === 'IN' ? lastSelectedItem?.Area : lastSelectedItem2?.Area) && (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="clear selection"
                                                        onClick={() => {
                                                            clearSelection('Area');
                                                            if (defaultType === 'IN') {  // NOSONAR
                                                                controllerField.onChange(null); // Update form state on clear
                                                            } else {
                                                                controllerField.onChange(null); // Update form state on clear
                                                            }
                                                        }}
                                                        edge="end"
                                                        sx={{ marginRight: '10%' }}
                                                    >
                                                        <ClearIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: '275px',
                                                    overflowY: 'auto',
                                                    fontSi: '13px',
                                                },
                                            },
                                        }}
                                    >

                                        {treeData && (
                                            <SimpleTreeView
                                                onItemSelectionToggle={(event, itemId, isSelected) => handleItemSelectionToggle(event, itemId, isSelected, 'Area')}
                                                expandedItems={expandedItems}
                                                onExpandedItemsChange={handleExpandedItemsChange}
                                                aria-label="icon expansion"
                                                // expansionTrigger="iconContainer"
                                                multiSelect
                                                checkboxSelection
                                                defaultSelectedItems={defaultType === 'IN' ? selectedItems : selectedItems2}
                                                onSelectedItemsChange={defaultType === 'IN' ? handleSelectedItemsChange : handleSelectedItemsChange2}
                                            >

                                                <style>
                                                    {`
                                                        .css-1w1m99i-MuiButtonBase-root-MuiCheckbox-root svg {
                                                            width: 16px !important; /* Set width to 16px */
                                                            height: 16px !important; /* Set height to 16px */
                                                        }
                                                    `}
                                                </style>
                                                <TreeItem
                                                    itemId={treeData?.AreaParentId}
                                                    label={treeData?.AreaParentName}
                                                    nodeId={treeData?.AreaParentId?.toString()}
                                                    sx={{
                                                        '& .MuiTreeItem-label': {
                                                            fontSize: '13px', // Custom font size
                                                        }
                                                    }}
                                                >
                                                    {treeData.Areas && renderTreeItems(treeData.Areas)}
                                                </TreeItem>
                                            </SimpleTreeView>
                                        )}
                                    </Select>
                                    {showErrorMessages && !selectedItems.length > 0 && <FormHelperText error sx={{ color: 'red' }}>Area is required</FormHelperText>}

                                </FormControl>


                            )}

                        />


                    </FormControl>

                </Box>
                <Box sx={{ mt: 1 }}>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        alignItems="center"
                        sx={{ padding: '2px' }}
                    >
                        {schemeDetails?.SchemeLock !== true && (
                            <Tooltip title="Save">
                                <IconButton type="button" onClick={() => saveData()} sx={{
                                    bgcolor: '#43b5a2',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    height: '30px',
                                    width: '31px',
                                    padding: '4px',
                                }}>
                                    <Iconify icon="bx:save" />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                </Box>


            </form>
            {showAlert && (
                <Stack sx={{ width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setAlertType('');
                                    setAlertMessage('');
                                    setShowAlert(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {alertMessage}
                    </Alert>
                </Stack>
            )}
            {
                loading && (
                    <LoadingProgressBar />
                )
            }
        </div>
    )
}